import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import "./index.css";
import FormularioEmpresa from "../../components/forms/FormularioEmpresa";
import FormularioUsuario from "../../components/forms/FormularioUsuario";
import { getRolesByCategory } from "../../Functions/papel/get-roles-by-category";
import CnpjUtils from "../../shared/utils/CnpjUtils";
import CpfUtils from "../../shared/utils/CpfUtils";
import RgUtils from "../../shared/utils/RgUtils";
import PhoneUtils from "../../shared/utils/PhoneUtils";
import EmailUtils from "../../shared/utils/EmailUtils";
import CepUtils from "../../shared/utils/CepUtils";
import Input from "../../components/inputs/input";
import InputLoading from "../../components/inputs/input-loading";
import Terms from "../../signup/modals/terms";
import Privacy from "../../signup/modals/privacy";

class TabelaEmpresas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedIndex: null,
      errors: {},
      loadingCep: {},
      papeisPorIndex: {},
      modalsPorIndex: {},
    };
    this.cepTimeouts = {};
    this.formularioEmpresaRefs = {};
    this.formularioUsuarioRefs = {};
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(null);
    }
    Object.values(this.cepTimeouts).forEach(timeout => {
      if (timeout) {
        clearTimeout(timeout);
      }
    });
  }

  toggleDetail = index => {
    this.setState(prevState => {
      const newExpandedIndex = prevState.expandedIndex === index ? null : index;

      if (newExpandedIndex === index) {
        const lista = this.props.dados || [];
        const item = lista[index];
        if (item && item.empresa && item.empresa[0]) {
          const conta = item.empresa[0].conta || {};
          const tipoParticipante = conta?.tipoDeParticipante || conta?.tipoParticipante || "";
          if (tipoParticipante && !prevState.papeisPorIndex[index]) {
            this.carregarPapeis(index, tipoParticipante);
          }
        }
      }

      return { expandedIndex: newExpandedIndex };
    });
  };

  validateField = (index, alvo, campo, valor) => {
    const errorKey = `${index}-${alvo}-${campo}`;
    const errors = { ...this.state.errors };
    valor = valor || "";

    const camposObrigatorios = [
      'tipoDeParticipante',
      'razaoSocial',
      'nomeFantasia',
      'cep',
      'logradouro',
      'numero',
      'bairro',
      'estado',
      'cidade',
      'email',
      'DDDCelular',
      'celular',
    ];

    const isMaskedField = campo === "telefoneDeTrabalho"
      || campo === "celular"
      || campo === "cep"
      || campo === "DDDCelular"
      || campo === "DDDTelefone"
    ;

    let isEmpty = false;
    if (isMaskedField) {
      const cleanedValue = PhoneUtils.cleanPhone(valor || '');

      switch (campo) {
        case "cep":
          isEmpty = cleanedValue.length !== 8;
          break;
        case "DDDCelular":
        case "DDDTelefone":
          isEmpty = cleanedValue.length !== 2;
          break;
        case "telefoneDeTrabalho":
        case "celular":
          isEmpty = cleanedValue.length < 8 || cleanedValue.length > 9;
          break;

        default:
          isEmpty = !valor || !valor.trim() || valor.includes("_");
          break;
      }
    }

    delete errors[errorKey];

    if (camposObrigatorios.includes(campo) && isEmpty) {
      errors[errorKey] = "Campo obrigatório";
    }

    if (campo === "email" && valor && !isEmpty) {
      if (!EmailUtils.validateEmail(valor)) {
        errors[errorKey] = "Email inválido";
      }
    }

    if ((campo === "DDDCelular" || campo === "DDDTelefone") && valor && !isEmpty) {
      const dddLimpo = PhoneUtils.cleanPhone(valor);
      if (dddLimpo.length !== 2) {
        errors[errorKey] = "DDD deve ter 2 dígitos";
      }
    }

    if ((campo === "telefoneDeTrabalho" || campo === "celular") && valor && !isEmpty) {
      const telefoneLimpo = PhoneUtils.cleanPhone(valor);
      if (telefoneLimpo.length < 8 || telefoneLimpo.length > 9) {
        errors[errorKey] = "Telefone deve ter 8 ou 9 dígitos";
      }
    }

    this.setState({ errors });
    return !errors[errorKey];
  };

  validateAllFields = (index) => {
    const dados = this.props.dados || [];
    if (!dados[index] || !dados[index].empresa || !Array.isArray(dados[index].empresa) || dados[index].empresa.length === 0) {
      return false;
    }

    const empresaInfo = dados[index].empresa[0];
    const conta = empresaInfo.conta || {};
    const dadosEmpresa = this.mapearDadosEmpresa(conta);
    const errors = {};
    let isValid = true;

    const camposObrigatorios = [
      { campo: 'tipoParticipante', label: 'Tipo de Participante' },
      { campo: 'razaoSocial', label: 'Razão Social' },
      { campo: 'nomeFantasia', label: 'Nome Fantasia' },
      { campo: 'cep', label: 'CEP' },
      { campo: 'logradouro', label: 'Logradouro' },
      { campo: 'numero', label: 'Número' },
      { campo: 'bairro', label: 'Bairro' },
      { campo: 'estado', label: 'Estado' },
      { campo: 'cidade', label: 'Cidade' },
      { campo: 'emailEmpresa', label: 'Email da Empresa' },
      { campo: 'dddCelular', label: 'DDD Celular', campoOEC: 'DDDCelular' },
      { campo: 'celular', label: 'Celular' }
    ];

    camposObrigatorios.forEach(({ campo, label }) => {
      const valor = dadosEmpresa[campo] || '';
      const errorKey = `${index}-empresa-${campo}`;

      const isMaskedField = campo === "celular" || campo === "cep" || campo === "dddCelular";

      let isEmpty = false;
      if (isMaskedField) {
        const cleanedValue = PhoneUtils.cleanPhone(valor);
        if (campo === "cep") {
          isEmpty = cleanedValue.length !== 8;
        } else if (campo === "dddCelular") {
          isEmpty = cleanedValue.length !== 2;
        } else if (campo === "celular") {
          isEmpty = cleanedValue.length < 8 || cleanedValue.length > 9;
        }
      } else {
        isEmpty = !valor || !valor.trim();
      }

      if (isEmpty) {
        errors[errorKey] = "Campo obrigatório";
        isValid = false;
      } else if (campo === "emailEmpresa") {
        if (!EmailUtils.validateEmail(valor)) {
          errors[errorKey] = "Email inválido";
          isValid = false;
        }
      } else if (campo === "dddCelular") {
        const dddLimpo = PhoneUtils.cleanPhone(valor);
        if (dddLimpo.length !== 2) {
          errors[errorKey] = "DDD deve ter 2 dígitos";
          isValid = false;
        }
      } else if (campo === "celular") {
        const telefoneLimpo = PhoneUtils.cleanPhone(valor);
        if (telefoneLimpo.length < 8 || telefoneLimpo.length > 9) {
          errors[errorKey] = "Telefone deve ter 8 ou 9 dígitos";
          isValid = false;
        }
      }
    });

    // Validar campos obrigatorios do usuario
    const usuarioInfo = dados[index].usuario || {};
    const dadosUsuario = this.mapearDadosUsuario(usuarioInfo);

    const camposObrigatoriosUsuario = [
      { campo: 'papel', campoOEC: 'Papel_c' },
      { campo: 'nome', campoOEC: 'Nome_c' },
      { campo: 'surname', campoOEC: 'Sobrenome_c' },
      { campo: 'email', campoOEC: 'Email_c' },
      { campo: 'datanasc', campoOEC: 'DataNascimento_c' },
      { campo: 'cpf', campoOEC: 'Documento_c' },
      { campo: 'rg', campoOEC: 'RG_c' },
      { campo: 'dddCelular', campoOEC: 'DDDCelular_c' },
      { campo: 'cellphone', campoOEC: 'Celular_c' },
    ];

    camposObrigatoriosUsuario.forEach(({ campo }) => {
      const valor = dadosUsuario[campo] || '';
      const errorKey = `${index}-usuario-${campo}`;
      const valorLimpo = valor.replace(/[_\/\.\-\s]/g, '');

      if (!valorLimpo || !valorLimpo.trim()) {
        errors[errorKey] = "Campo obrigatório";
        isValid = false;
      } else if (campo === 'email' && !EmailUtils.validateEmail(valor)) {
        errors[errorKey] = "Email inválido";
        isValid = false;
      } else if (campo === 'datanasc' && !this.dataNascimentoValida(valor)) {
        errors[errorKey] = "Data inválida";
        isValid = false;
      } else if (campo === 'dddCelular') {
        const dddLimpo = PhoneUtils.cleanPhone(valor);
        if (dddLimpo.length !== 2) {
          errors[errorKey] = "DDD inválido";
          isValid = false;
        }
      } else if (campo === 'cellphone') {
        const telLimpo = PhoneUtils.cleanPhone(valor);
        if (telLimpo.length < 8 || telLimpo.length > 9) {
          errors[errorKey] = "Celular inválido";
          isValid = false;
        }
      }
    });

    const dddTelefone = PhoneUtils.cleanPhone(dadosUsuario.dddTelefone || '');
    const telefone = PhoneUtils.cleanPhone(dadosUsuario.telephone || '');

    if (dddTelefone || telefone) {
      if (dddTelefone.length !== 2) {
        errors[`${index}-usuario-dddTelefone`] = telefone ? "Informe o DDD" : "DDD inválido";
        isValid = false;
      }
      if (telefone.length < 8 || telefone.length > 9) {
        errors[`${index}-usuario-telephone`] = telefone ? "Telefone inválido" : "Informe o telefone ou apague o DDD";
        isValid = false;
      }
    }

    this.setState(prev => ({
      errors: { ...prev.errors, ...errors }
    }));
    return isValid;
  };

  dataNascimentoValida = (valor) => {
    const partes = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(valor || "");
    if (!partes) {
      return false;
    }

    const dia = Number(partes[1]);
    const mes = Number(partes[2]);
    const ano = Number(partes[3]);
    const data = new Date(ano, mes - 1, dia);

    return data.getFullYear() === ano && data.getMonth() === mes - 1 && data.getDate() === dia && ano >= 1900 && data <= new Date();
  };

  renderInput = (index, alvo, campo, label, valor, readOnly = false) => {
    const aplicarMascara = (campo, valor) => {
      let somenteNumeros = valor.replace(/\D/g, "");

      if (campo === "DDDCelular" || campo === "DDDTelefone") {
        return somenteNumeros.slice(0, 2);
      }

      if (campo === "celular") {
        somenteNumeros = somenteNumeros.slice(0, 9);
        if (somenteNumeros.length > 5) {
          return somenteNumeros.replace(/(\d{5})(\d{0,4})/, "$1-$2");
        }
        return somenteNumeros;
      }

      if (campo === "telefoneDeTrabalho") {
        somenteNumeros = somenteNumeros.slice(0, 9);
        if (somenteNumeros.length > 5) {
          return somenteNumeros.replace(/(\d{5})(\d{0,4})/, "$1-$2");
        } else if (somenteNumeros.length > 4) {
          return somenteNumeros.replace(/(\d{4})(\d{0,4})/, "$1-$2");
        }
        return somenteNumeros;
      }

      return valor;
    };

    let mask = null;
    let maxLength = null;

    if (campo === "DDDCelular" || campo === "DDDTelefone") {
      mask = [/\d/, /\d/];
      maxLength = 2;
    } else if (campo === "celular") {
      mask = [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
      maxLength = 10;
    } else if (campo === "telefoneDeTrabalho") {
      mask = [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
      maxLength = 10;
    } else if (campo === "cep") {
      mask = [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
      maxLength = 9;
    }

    const inputId = `input-${index}-${alvo}-${campo}`;
    const errorKey = `${index}-${alvo}-${campo}`;
    const errorMessage = this.state.errors[errorKey];

    const camposObrigatorios = [
      'tipoDeParticipante', 'razaoSocial', 'nomeFantasia', 'cep', 'logradouro',
      'numero', 'bairro', 'estado', 'cidade', 'email', 'DDDCelular', 'celular'
    ];
    const isRequired = camposObrigatorios.includes(campo) && !readOnly;
    const labelComAsterisco = isRequired ? `${label}*` : label;

    const camposAutoPreenchidos = ['logradouro', 'bairro', 'cidade', 'estado'];
    const isLoadingCep = camposAutoPreenchidos.includes(campo) && this.state.loadingCep[index];

    return (
      <div style={{ position: "relative" }}>
      <Input
        id={inputId}
        name={campo}
        type={campo === "email" ? "email" : "text"}
        label={labelComAsterisco}
        value={valor || ""}
        readOnly={readOnly}
        mask={mask}
        maxLength={maxLength}
        required={isRequired}
        className={errorMessage ? "has-error" : ""}
        disabled={isLoadingCep}
        onChange={e => {
            let valorFormatado = aplicarMascara(campo, e.target.value);

            if (campo === "cep" && !readOnly) {
              const cepLimpo = PhoneUtils.cleanPhone(valorFormatado);

              if (this.cepTimeouts && this.cepTimeouts[index]) {
                clearTimeout(this.cepTimeouts[index]);
                this.cepTimeouts[index] = null;
              }

              if (cepLimpo.length === 8) {
                if (!this.cepTimeouts) {
                  this.cepTimeouts = {};
                }

                this.cepTimeouts[index] = setTimeout(async () => {
                  this.setState(prevState => ({
                    loadingCep: { ...prevState.loadingCep, [index]: true }
                  }));

                  const timeoutPromise = new Promise((_, reject) => {
                    setTimeout(() => reject(new Error('Timeout')), 5000);
                  });

                  try {
                    const endereco = await Promise.race([
                      CepUtils.buscarEndereco(cepLimpo),
                      timeoutPromise
                    ]);

                    if (endereco) {
                      const camposAtualizados = {
                        logradouro: endereco.logradouro || "",
                        bairro: endereco.bairro || "",
                        cidade: endereco.cidade || "",
                        estado: endereco.estado || ""
                      };

                      if (endereco.cep) {
                        camposAtualizados.cep = endereco.cep;
                      }

                      if (this.props.onUpdateMultiple) {
                        this.props.onUpdateMultiple(index, alvo, camposAtualizados);
                      } else {
                        Object.keys(camposAtualizados).forEach(campo => {
                          this.props.onUpdate(index, alvo, campo, camposAtualizados[campo]);
                        });
                      }
                    }
                  } catch (error) {
                    console.warn("Erro ao buscar CEP:", error);
                  } finally {
                    this.setState(prevState => ({
                      loadingCep: { ...prevState.loadingCep, [index]: false }
                    }));
                  }
                }, 150);
              } else {
                this.setState(prevState => ({
                  loadingCep: { ...prevState.loadingCep, [index]: false }
                }));
              }
            }

          this.props.onUpdate(index, alvo, campo, valorFormatado);

            if (!readOnly) {
              this.validateField(index, alvo, campo, valorFormatado);
            }

            const valorLimpo = valorFormatado.replace(/\D/g, "");
            if ((campo === "DDDCelular" || campo === "DDDTelefone") && valorLimpo.length === 2) {
              setTimeout(() => {
                const campoDestino = campo === "DDDCelular" ? "celular" : "telefoneDeTrabalho";
                const inputDestinoId = `input-${index}-${alvo}-${campoDestino}`;
                const inputDestino = document.getElementById(inputDestinoId);
                if (inputDestino) {
                  inputDestino.focus();
                } else {
                  const container = document.querySelector(`[id="${inputDestinoId}"]`);
                  if (container) {
                    const input = container.querySelector(`input[name="${campoDestino}"]`);
                    if (input) {
                      input.focus();
                    }
                  }
                }
              }, 50);
            }
          }}
          onFocus={e => {
            if (e.target && e.target.classList) {
              e.target.classList.remove("has-error");
            }
        }}
        width="100%"
      />
        <InputLoading show={isLoadingCep} right="30px" />
        <span className="field-error-message" style={{ visibility: errorMessage ? "visible" : "hidden" }}>
          {errorMessage || "Campo obrigatório"}
        </span>
      </div>
    );
  };

  formatarCNPJ = (cnpj) => {
    if (!cnpj) return "";
    const clean = cnpj.replace(/[^A-Za-z0-9]/g, "").toUpperCase().slice(0, 14);
    let formatted = clean;
    if (clean.length > 2) formatted = clean.slice(0, 2) + "." + clean.slice(2);
    if (clean.length > 5) formatted = clean.slice(0, 2) + "." + clean.slice(2, 5) + "." + clean.slice(5);
    if (clean.length > 8) formatted = clean.slice(0, 2) + "." + clean.slice(2, 5) + "." + clean.slice(5, 8) + "/" + clean.slice(8);
    if (clean.length > 12) formatted = clean.slice(0, 2) + "." + clean.slice(2, 5) + "." + clean.slice(5, 8) + "/" + clean.slice(8, 12) + "-" + clean.slice(12);
    return formatted;
  };

  mapearDadosEmpresa = (conta) => {
    let dddCelular = conta?.DDDCelular || "";
    let celular = conta?.celular || "";

    if (!dddCelular && celular) {
      const celularLimpo = PhoneUtils.cleanPhone(celular);
      if (celularLimpo.length >= 11) {
        dddCelular = celularLimpo.substring(0, 2);
        celular = celularLimpo.substring(2);
      } else if (celularLimpo.length >= 10) {
        dddCelular = celularLimpo.substring(0, 2);
        celular = celularLimpo.substring(2);
      }
    }

    let dddTelefone = conta?.DDDTelefone || "";
    let telefone = conta?.telefoneDeTrabalho || "";

    if (!dddTelefone && telefone) {
      const telefoneLimpo = PhoneUtils.cleanPhone(telefone);
      if (telefoneLimpo.length >= 10) {
        dddTelefone = telefoneLimpo.substring(0, 2);
        telefone = telefoneLimpo.substring(2);
      }
    }

    return {
      cnpj: CnpjUtils.cleanCnpj(conta?.cnpj || ""),
      tipoParticipante: conta?.tipoDeParticipante || conta?.tipoParticipante || "",
      razaoSocial: conta?.razaoSocial || "",
      nomeFantasia: conta?.nomeFantasia || "",
      cep: conta?.cep || "",
      logradouro: conta?.logradouro || "",
      numero: conta?.numero || "",
      complemento: conta?.complemento || "",
      bairro: conta?.bairro || "",
      pontoReferencia: conta?.pontoDeReferencia || conta?.pontoReferencia || "",
      estado: conta?.estado || "",
      cidade: conta?.cidade || "",
      emailEmpresa: conta?.email || "",
      dddCelular: dddCelular,
      celular: celular,
      dddTelefone: dddTelefone,
      telefone: telefone,
    };
  };

  mapearDadosUsuario = (usuario) => {
    let datanasc = "";
    if (usuario?.DataNasc_c) {
      const dataStr = usuario.DataNasc_c.split("T")[0];
      const partes = dataStr.split("-");
      if (partes.length === 3) {
        datanasc = `${partes[2]}/${partes[1]}/${partes[0]}`;
      } else {
        datanasc = usuario.DataNasc_c;
      }
    } else if (usuario?.DataNascimento_c) {
      const dataStr = usuario.DataNascimento_c.split("T")[0];
      const partes = dataStr.split("-");
      if (partes.length === 3) {
        datanasc = `${partes[2]}/${partes[1]}/${partes[0]}`;
      } else {
        datanasc = usuario.DataNascimento_c;
      }
    }

    let dddCelular = usuario?.DDDCelular_c || "";
    let cellphone = usuario?.Celular_c || "";

    if (!dddCelular && cellphone) {
      const celularLimpo = PhoneUtils.cleanPhone(cellphone);
      if (celularLimpo.length >= 11) {
        dddCelular = celularLimpo.substring(0, 2);
        cellphone = celularLimpo.substring(2);
      } else if (celularLimpo.length >= 10) {
        dddCelular = celularLimpo.substring(0, 2);
        cellphone = celularLimpo.substring(2);
      }
    }

    let dddTelefone = usuario?.DDDTelefone_c || "";
    let telephone = usuario?.Telefone_c || "";

    if (!dddTelefone && telephone) {
      const telefoneLimpo = PhoneUtils.cleanPhone(telephone);
      if (telefoneLimpo.length >= 10) {
        dddTelefone = telefoneLimpo.substring(0, 2);
        telephone = telefoneLimpo.substring(2);
      }
    }

    return {
      nome: usuario?.Nome_c || "",
      surname: usuario?.Sobrenome_c || "",
      email: usuario?.Email_c || "",
      email1: usuario?.Email_c || "",
      papel: usuario?.Papel_c || "",
      datanasc: datanasc,
      cpf: CpfUtils.cleanCpf(usuario?.Documento_c || ""),
      rg: RgUtils.cleanRg(usuario?.RG_c || ""),
      dddTelefone: dddTelefone,
      telephone: telephone,
      dddCelular: dddCelular,
      cellphone: cellphone,
    };
  };

  carregarPapeis = async (index, tipoParticipante) => {
    if (!tipoParticipante) {
      this.setState(prevState => ({
        papeisPorIndex: { ...prevState.papeisPorIndex, [index]: [] }
      }));
      return;
    }

    try {
      const mapeamentoPerfil = {
        "OTICA": {
          categoria: "OTICA",
          papelExcluir: "Novo Usuário Óptica"
        },
        "OTICA_PRODUTORA": {
          categoria: "OTICA",
          papelExcluir: "Novo Usuário Óptica"
        },
        "LABORATORIO": {
          categoria: "LAB_INDEPENDENTE",
          papelExcluir: "Novo Usuário Lab Independente"
        }
      };

      const config = mapeamentoPerfil[tipoParticipante];
      if (!config) {
        this.setState(prevState => ({
          papeisPorIndex: { ...prevState.papeisPorIndex, [index]: [] }
        }));
        return;
      }

      const { categoria, papelExcluir } = config;
      let papeis = await getRolesByCategory(categoria, 1);

      if (papeis?.status && papeis.status !== "sucesso") {
        console.error("Erro ao buscar papéis da API OEC:", papeis);
        this.setState(prevState => ({
          papeisPorIndex: { ...prevState.papeisPorIndex, [index]: [] }
        }));
        return;
      }

      const opcoesFiltradas = Array.isArray(papeis?.items)
        ? papeis.items
            .filter(item => {
              const temEditadoUsuario = item?.EditadoUsuario === true || item?.EditadoUsuario === "true" || item?.EditadoUsuario === 1;
              const naoEhExcluido = item?.recordName && item.recordName.trim().toLowerCase() !== papelExcluir.trim().toLowerCase();
              return temEditadoUsuario && naoEhExcluido;
            })
            .map(item => ({
              label: item.recordName,
              value: item.recordName,
            }))
        : [];

      this.setState(prevState => ({
        papeisPorIndex: { ...prevState.papeisPorIndex, [index]: opcoesFiltradas }
      }));
    } catch (error) {
      console.error("Erro ao buscar papeis:", error);
      this.setState(prevState => ({
        papeisPorIndex: { ...prevState.papeisPorIndex, [index]: [] }
      }));
    }
  };

  clearFieldError = (index, alvo, campo) => {
    const errorKey = `${index}-${alvo}-${campo}`;
    if (this.state.errors[errorKey]) {
      this.setState(prev => {
        const errors = { ...prev.errors };
        delete errors[errorKey];
        return { errors };
      });
    }
  };

  handleChangeEmpresa = (index, name, value) => {
    const mapeamentoCampos = {
      tipoParticipante: "tipoDeParticipante",
      emailEmpresa: "email",
      dddCelular: "DDDCelular",
      dddTelefone: "DDDTelefone",
      telefone: "telefoneDeTrabalho",
      pontoReferencia: "pontoDeReferencia",
    };

    const campoOEC = mapeamentoCampos[name] || name;

    if (name === "tipoParticipante") {
      this.carregarPapeis(index, value);
      this.props.onUpdate(index, "usuario", "Papel_c", "");
    }

    this.clearFieldError(index, "empresa", name);
    this.props.onUpdate(index, "empresa", campoOEC, value);
  };

  handleChangeUsuario = (index, name, value) => {
    const mapeamentoCampos = {
      nome: "Nome_c",
      surname: "Sobrenome_c",
      email: "Email_c",
      email1: "Email_c",
      papel: "Papel_c",
      datanasc: "DataNasc_c",
      cpf: "Documento_c",
      rg: "RG_c",
      dddTelefone: "DDDTelefone_c",
      telephone: "Telefone_c",
      dddCelular: "DDDCelular_c",
      cellphone: "Celular_c",
    };

    if (name === "datanasc" || name === "cpf" || name === "rg") {
      const somenteDigitos = (value || "").replace(/\D/g, "");
      if (!somenteDigitos) {
        value = "";
      }
    }

    const campoOEC = mapeamentoCampos[name] || name;
    this.clearFieldError(index, "usuario", name);

    const telefones = {
      dddCelular: ["DDDCelular_c", "Celular_c", "dddCelular", "cellphone"],
      cellphone: ["DDDCelular_c", "Celular_c", "dddCelular", "cellphone"],
      dddTelefone: ["DDDTelefone_c", "Telefone_c", "dddTelefone", "telephone"],
      telephone: ["DDDTelefone_c", "Telefone_c", "dddTelefone", "telephone"],
    };

    if (telefones[name] && this.props.onUpdateMultiple) {
      const [chaveDdd, chaveNumero, campoDdd, campoNumero] = telefones[name];
      const atuais = this.mapearDadosUsuario((this.props.dados || [])[index]?.usuario);

      if (campoDdd === "dddTelefone") {
        this.clearFieldError(index, "usuario", campoDdd);
        this.clearFieldError(index, "usuario", campoNumero);
      }

      this.props.onUpdateMultiple(index, "usuario", {
        [chaveDdd]: name === campoDdd ? value : atuais[campoDdd],
        [chaveNumero]: name === campoNumero ? value : atuais[campoNumero],
      });
      return;
    }

    this.props.onUpdate(index, "usuario", campoOEC, value);
  };

  handleCheckboxChange = (index, e) => {
    const { name, checked } = e.target;

    if (name === "terms" && checked) {
      this.setState(prevState => ({
        modalsPorIndex: {
          ...prevState.modalsPorIndex,
          [index]: {
            ...prevState.modalsPorIndex[index],
            showTerms: true,
          }
        }
      }));
    }
  };

  handleCloseTermsModal = (index) => {
    this.setState(prevState => ({
      modalsPorIndex: {
        ...prevState.modalsPorIndex,
        [index]: {
          ...prevState.modalsPorIndex[index],
          showTerms: false,
          showPrivacy: true,
        }
      }
    }));
  };

  handleClosePrivacyModal = (index) => {
    this.setState(prevState => ({
      modalsPorIndex: {
        ...prevState.modalsPorIndex,
        [index]: {
          ...prevState.modalsPorIndex[index],
          showPrivacy: false,
        }
      }
    }));
  };

  handleUpdateMultipleEmpresa = (index, campos) => {
    const camposMapeados = {};
    Object.keys(campos).forEach(key => {
      const mapeamentoCampos = {
        emailEmpresa: "email",
        dddCelular: "DDDCelular",
        dddTelefone: "DDDTelefone",
        telefone: "telefoneDeTrabalho",
        pontoReferencia: "pontoDeReferencia",
      };
      camposMapeados[mapeamentoCampos[key] || key] = campos[key];
    });

    this.props.onUpdateMultiple(index, "empresa", camposMapeados);
  };

  render() {
    const { dados, mostrarAcoes } = this.props;
    const lista = dados || [];

    return (
      <div className="container my-4 px-2 dash gestao-cadastro">
        <Table className="text-center table table-striped" hover>
          <thead className="gestao-cadastro-faturas-table-head">
            <tr>
              <th className="gestao-cadastro-faturas-table-head-th"></th>
              {/* <th className="gestao-cadastro-faturas-table-head-th">Status</th> */}
              <th className="gestao-cadastro-faturas-table-head-th">Data Cadastro</th>
              <th className="gestao-cadastro-faturas-table-head-th">CNPJ</th>
              <th className="gestao-cadastro-faturas-table-head-th">Nome Fantasia</th>
              <th className="gestao-cadastro-faturas-table-head-th">Tipo Participante</th>
            </tr>
          </thead>
          <tbody>
            {lista.length === 0 && (
              <tr>
                <td colSpan={6} className="gestao-cadastro-empty">
                  Nenhuma empresa encontrada.
                </td>
              </tr>
            )}
            {lista.map((item, index) => {
              if (!item.empresa || !Array.isArray(item.empresa) || item.empresa.length === 0) {
                return null;
              }

              const empresaInfo = item.empresa[0];
              if (!empresaInfo) {
                return null;
              }

              const conta = empresaInfo.conta || {};
              const usuario = item.usuario || {};

              const statusItem = item.status || conta.statusCadastro || conta.status || "PENDENTE";
              const statusPendente = statusItem === "PENDENTE" || statusItem === "PENDENTE_APROVACAO";

              const getStatusLabel = (status) => {
                if (status === "PENDENTE" || status === "PENDENTE_APROVACAO") return "PENDENTE";
                if (status === "APROVADO") return "APROVADO";
                if (status === "REPROVADO") return "REPROVADO";
                return status;
              };

              const getStatusColor = (status) => {
                if (status === "PENDENTE" || status === "PENDENTE_APROVACAO") return "#ffc107";
                if (status === "APROVADO") return "#28a745";
                if (status === "REPROVADO") return "#dc3545";
                return "#6c757d";
              };

              const tiposDeParticipante = [
                { label: "Ótica", value: "OTICA" },
                { label: "Ótica Produtora", value: "OTICA_PRODUTORA" },
                { label: "Laboratório", value: "LABORATORIO" },
              ]
              const tipoDeParticipante = tiposDeParticipante.find(tipo => tipo.value === conta?.tipoDeParticipante || conta?.tipoParticipante || "")?.label || "";

              const dataCadastro = empresaInfo.inclusao || empresaInfo.inclusão
                ? new Date(empresaInfo.inclusao || empresaInfo.inclusão).toLocaleDateString("pt-BR")
                : "N/A";

              const empresaId = empresaInfo?.Id || conta?.cnpj || `empresa-${index}`;
              const userId = usuario?.Id || usuario?.Email_c || `user-${index}`;
              const uniqueKey = `${userId}-${empresaId}-${index}`;

              // Extrair erros para empresa e usuario do index atual
              const empresaErrors = {};
              const usuarioErrors = {};
              Object.keys(this.state.errors).forEach(key => {
                const prefixEmpresa = `${index}-empresa-`;
                const prefixUsuario = `${index}-usuario-`;
                if (key.startsWith(prefixEmpresa)) {
                  empresaErrors[key.replace(prefixEmpresa, "")] = this.state.errors[key];
                } else if (key.startsWith(prefixUsuario)) {
                  usuarioErrors[key.replace(prefixUsuario, "")] = this.state.errors[key];
                }
              });

              return (
                <React.Fragment key={uniqueKey}>
                  <tr onClick={() => this.toggleDetail(index)} style={{ cursor: "pointer" }}>
                    <td>{this.state.expandedIndex === index ? <BsChevronUp size={12} color="#3f51b5" /> : <BsChevronDown size={12} color="#3f51b5" />}</td>
                    <td>{dataCadastro}</td>
                    <td>{this.formatarCNPJ(conta?.cnpj)}</td>
                    <td>{conta?.nomeFantasia}</td>
                    <td>{tipoDeParticipante}</td>
                  </tr>

                  {this.state.expandedIndex === index && (
                    <tr>
                      <td colSpan={6}>
                        <div className="p-3" style={{ backgroundColor: "#f8f9fa" }}>
                          <div className="container-fluid">
                            <h5 className="mt-3">Empresa:</h5>
                            <FormularioEmpresa
                              ref={ref => { this.formularioEmpresaRefs[index] = ref; }}
                              values={this.mapearDadosEmpresa(conta)}
                              errors={empresaErrors}
                              readOnlyFields={statusPendente ? ["cnpj"] : ["cnpj"]}
                              readOnly={!mostrarAcoes}
                              onChange={(name, value) => this.handleChangeEmpresa(index, name, value)}
                              onUpdateMultiple={(campos) => this.handleUpdateMultipleEmpresa(index, campos)}
                              showLabels={false}
                            />
                            <hr />

                            <h5 className="mt-3">Usuário:</h5>
                            <FormularioUsuario
                              ref={ref => { this.formularioUsuarioRefs[index] = ref; }}
                              values={this.mapearDadosUsuario(usuario)}
                              errors={usuarioErrors}
                              papeis={this.state.papeisPorIndex[index] || []}
                              readOnlyFields={statusPendente ? ["email"] : ["email"]}
                              readOnly={!mostrarAcoes}
                              onChange={(name, value) => this.handleChangeUsuario(index, name, value)}
                              onCheckboxChange={(e) => this.handleCheckboxChange(index, e)}
                              showLabels={false}
                              showPasswordFields={false}
                              showTermsFields={false}
                              showEmailConfirmation={false}
                              showPerfil={true}
                              onlyS9={false}
                            />

                            {this.state.modalsPorIndex[index]?.showTerms && (
                              <>
                                <div
                                  className="x-overlay is--active"
                                  onClick={() => this.handleCloseTermsModal(index)}
                                  style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 99998 }}
                                ></div>
                                <Terms onClick={() => this.handleCloseTermsModal(index)} />
                              </>
                            )}
                            {this.state.modalsPorIndex[index]?.showPrivacy && (
                              <>
                                <div
                                  className="x-overlay is--active"
                                  onClick={() => this.handleClosePrivacyModal(index)}
                                  style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 99998 }}
                                ></div>
                                <Privacy onClick={() => this.handleClosePrivacyModal(index)} />
                              </>
                            )}

                            {mostrarAcoes && (
                              <div className="mt-5 d-flex justify-content-center gap-2">
                                <button className="btn btn-success" onClick={() => this.props.handleDecision("aprovar", empresaInfo, index)}>
                                  APROVAR
                                </button>
                                <button className="btn btn-danger" onClick={() => this.props.handleDecision("reprovar", empresaInfo, index)}>
                                  REPROVAR
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default TabelaEmpresas;
